import React, { useEffect, useState } from "react";
import "./SubSkillCard.scss";
import { SubSkillCardInterface } from "../../../interfaces";
import { Card, CardContent } from "@material-ui/core";
import LinearProgress from '@material-ui/core/LinearProgress';
import translate from "../../../i18n/translate";
import withStyles from "@material-ui/core/styles/withStyles";
import { useSelector } from "react-redux";

const LinearProgressThick = withStyles((theme) => ({
  root: {
    height: 7,
    borderRadius: 10,
  },
}))(LinearProgress);

const SubSkillCard = (props: SubSkillCardInterface) => {
  const allInfo = useSelector((state: any) => state);
  const [badge, setBadge] = useState("");

  useEffect(()=> {
    if(allInfo.skillOutcomeSummary.data && allInfo.skillOutcomeSummary.data.length > 0) {
      let matchedSkillNamesList = allInfo.skillOutcomeSummary.data.filter((summary : any) => {
        return summary.skill_name === props.subSkillData.skilltitle
      });
      if(matchedSkillNamesList.length > 0 ) {
        let isBadgeAvailable = matchedSkillNamesList.filter((summary : any) => summary.skill_name === props.subSkillData.skilltitle)
        if(isBadgeAvailable[0].skill_summary[0].badge !== "No Badge") {
          setBadge(allInfo.skillOutcomeSummary.data.filter((summary : any) => summary.skill_name===props.subSkillData.skilltitle)[0].skill_summary[0].badge);
        }
      }
    }
  },[allInfo.skillOutcomeSummary, props]);

  const getIncompleteStatus = (skillData: any) => {     
    const lowerStatus: string =  skillData.sessionstatus ? skillData.sessionstatus.toLowerCase() : "";
    switch(lowerStatus) {
      case 'completed':
        return translate("progress_subskill_sessionStatusCompleted");
      case 'absent':
        return translate("progress_subskill_sessionStatusAbsent");
      case 'upcoming':
        return translate("progress_subskill_sessionStatusUpcoming");
      case 'scheduled':
        return translate("progress_subskill_sessionStatusScheduled");
      case 'scheduling':
        return translate("progress_subskill_sessionStatusScheduling");
      default: 
        return translate("progress_subskill_sessionStatusNotCompleted");
    }           
  }

  const getSessionStatus = () => {
    if(parseInt(props.subSkillData.sessioncompleted) !== 0) {
      if(props.subSkillData.sessionstatus === "2") {
        return <span className="sess-text-completed">{translate("progress_subskill_sessionStatusCompleted")}</span>
      } else if(props.subSkillData.sessionstatus === "3") {
        return <span className="sess-text-completed">{translate("progress_subskill_sessionStatusAbsent")}</span>
      } else {
        return <span className="sess-text">{getIncompleteStatus(props.subSkillData)}</span>
      }
    } else {
      return <span className="sess-text">{translate("progress_subskill_sessionStatusNoSessions")}</span>
    }
  }

  return (
    <React.Fragment>
      {props.subSkillData.subskilltitle &&
        <Card className="subskill-card">
          <CardContent className="subskill-card-body">
            <div className="subskill-list-title">{props.subSkillData.subskilltitle}   
            </div>
            <div className="subskill-list-body">
            { <div className="subskill-progress-block">
                <div className="subskill-progress-block-1">
                  {!props.isElevate && <div className="subskill-progress-label">{translate("progress_subskill_preworkTitle")}</div>}
                  <div className={(allInfo.common.productID === "25") ? "subskill-progress-bar-elevate" : "subskill-progress-bar"}>
                    <LinearProgressThick variant="determinate" value={parseInt(props.subSkillData.totalprework) !== 0 ? (parseInt(props.subSkillData.preworkcompleted) / parseInt(props.subSkillData.totalprework)) * 100 : 0} />
                  </div>
                </div>
                {
                  props.showHomeWork && (
                    <div className="subskill-progress-block-2">
                    <div className="subskill-progress-label">{translate("progress_subskill_homeworkTitle")}</div>
                    <div className="subskill-progress-bar">
                      <LinearProgressThick variant="determinate" value={parseInt(props.subSkillData.totalhomework) !== 0 ? (parseInt(props.subSkillData.homeworkcompleted) / parseInt(props.subSkillData.totalhomework)) * 100 : 0} />
                    </div>
                  </div>
                  )
                }
                {badge && <div className="subskill-progress-label">{translate("progress_overall_card_title_badge")}</div>}
                {badge && <div>
                <img className="subskill-unit-badge" src={process.env["REACT_APP_ASSETS_URL"]+"/halo/badges/businessskills/essential/" + badge.toLowerCase()+"-restaurants-and-hotels.svg"}  alt="unit-badge"/> 
                </div>
                }
              </div>
            }
            { !props.isSolo && !props.isElevate &&
              <div className={`${props.showHomeWork ? "subskill-progress-session-block" : "subskill-progress-session-block no-hw"}`}>
                {translate("progress_subskill_sessionTitle")} 
                <br/>
                {getSessionStatus()}
                <br />              
                {props.subSkillData.sessionCompletedDate ? <span className="sess-text-date">{props.subSkillData.sessionCompletedDate}</span> : <span  className="sess-text">{translate("progress_subskill_sessionNoDate")}</span>}
            </div>
            }
            { props.isElevate && !props.isSolo &&
              <div className={"subskill-progress-session-block subskill-progress-session-elevate-block"}>
                {translate("progress_subskill_sessionTitle")} 
                  <br />
                { props.subSkillData.sessionStatus === "finished" ?
                  <span className="sess-text-completed">
                    {translate("progress_subskill_sessionStatusCompleted")}
                  </span> 
                : 
                  <span className="sess-text-completed">
                    {translate("progress_subskill_sessionStatusAbsent")}
                  </span>
                }
                <br />              
                {props.subSkillData.sessioncompleteddate ?
                  <span className="sess-text-date">
                    {props.subSkillData.sessioncompleteddate}
                  </span> 
                : <span className="sess-text">
                  {translate("progress_subskill_sessionNoDate")}
                  </span>
                }
            </div>
            }
            </div>
          </CardContent>
        </Card>
      }
    </React.Fragment>
  )
};

export default SubSkillCard;
